import React from 'react';
import { Modal, Table, Tooltip } from 'antd';
import { Info } from '@phosphor-icons/react';
import DashboardModal from './DashboardModal';
import { useOneButtonStore } from '../../../../store/oneButtonStore';
import { getFinancePartnerCreditStatusList, getCreditRowStatus } from './contactCreditStatus';
import './oneButton-css/CreditStatusModal.css';

export interface CreditStatusModalProps {
    open: boolean;
    onClose: () => void;
    contact: any;
    primaryFinancePartner: string;
}

export const CreditStatusModal: React.FC<CreditStatusModalProps> = ({
    open,
    onClose,
    contact,
    primaryFinancePartner,
}) => {
    const theme = useOneButtonStore((s) => s.theme);

    const formatDate = (dateVal: any) => {
        if (!dateVal) return '';
        const d = new Date(dateVal);
        if (isNaN(d.getTime())) return '';
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        const year = d.getFullYear();
        return `${month}-${day}-${year}`;
    };

    const creditStatusColumns = [
        {
            title: 'Product',
            key: 'productTypeName',
            render: (_: any, record: any) => record.productTypeName || record.ProductTypeName || ''
        },
        {
            title: 'Finance Partner',
            dataIndex: 'Finance_Partner_Name',
            key: 'Finance_Partner_Name',
        },
        {
            title: 'Credit On',
            key: 'creditOn',
            render: (_: any, record: any) => {
                const dateVal = record.creditOn || record.CreditOn;
                return formatDate(dateVal);
            }
        },
        {
            title: 'Expires On',
            key: 'expireOn',
            render: (_: any, record: any) => {
                const dateVal = record.expireOn || record.ExpireOn;
                return formatDate(dateVal);
            }
        },
        {
            title: 'Status',
            key: 'status',
            render: (_: any, record: any) => {
                const hasSyncContactId = contact?.Finance_Partner_Sync_ContactId || contact?.finance_Partner_Sync_ContactId;
                const statusNum = getCreditRowStatus(record, !!hasSyncContactId, primaryFinancePartner);
                switch(statusNum) {
                    case 1: return <span>Expired</span>;
                    case 2: return <span>Passed</span>;
                    case 3: return <span>Pending</span>;
                    case 4: return (
                        <span>
                            Declined
                            {record.Credit_Declined_Reason && (
                                <Tooltip title={record.Credit_Declined_Reason} placement="topLeft">
                                    <Info style={{ marginLeft: 8, fontSize: 12, display: 'inline-flex', verticalAlign: 'middle' }} />
                                </Tooltip>
                            )}
                        </span>
                    );
                    default: return <span>-</span>;
                }
            }
        }
    ];

    const creditStatusList = contact ? getFinancePartnerCreditStatusList(contact) : [];

    return (
        <DashboardModal
            title="Credit status"
            open={open}
            onClose={onClose}
            width={800}
            destroyOnClose
            theme={theme}
        >
            <div style={{ padding: '8px 24px 24px' }}>
                <Table
                    dataSource={creditStatusList}
                    columns={creditStatusColumns}
                    pagination={false}
                    rowKey={(record: any) => record.id || record.Id || Math.random().toString()}
                    className={`obd-credit-status-modal__table obd-theme-${theme}`}
                />
            </div>
        </DashboardModal>
    );
};
